import { RigidBodyBundle } from "../rigidBodyBundle";
export class PluginBodyBundle extends RigidBodyBundle {
    info;
    localTransform;
    localTransformInverse;
    constructor(runtime, info) {
        const shape = info.getShape(0);
        let localTransform = null;
        if (shape !== null) {
            localTransform = shape.localTransform;
            for (let i = 0; i < info.count; ++i) {
                info.setCollisionGroup(i, shape.collisionGroup);
                info.setCollisionMask(i, shape.collisionMask);
            }
            const material = shape.material;
            if (material) {
                for (let i = 0; i < info.count; ++i) {
                    info.setFriction(i, material.friction);
                    info.setRestitution(i, material.restitution);
                }
            }
        }
        super(runtime, info);
        this.info = info;
        this.localTransform = localTransform;
        this.localTransformInverse = localTransform?.invert() ?? null;
    }
    setDamping(index, linearDamping, angularDamping) {
        super.setDamping(index, linearDamping, angularDamping);
        this.info.setLinearDamping(index, linearDamping);
        this.info.setAngularDamping(index, angularDamping);
    }
    setMassProps(index, mass, localInertia) {
        super.setMassProps(index, mass, localInertia);
        this.info.setMass(index, mass);
        this.info.setLocalInertia(index, localInertia);
    }
    get length() {
        return this.count;
    }
}
